import { get } from 'services/api/base';

import { GetSingleCampaignRequest, GetSingleCampaignResponse } from './types-get-single-campaign';

export function getMerchantSingleCampaign(payload: GetSingleCampaignRequest): Promise<GetSingleCampaignResponse> {
  return get(`v5/merchant/campaigns/${payload.id}`).json();
}
